<div class="flex-1 overflow-auto">
  <div
    class="flex flex-wrap justify-content-center sm:flex-column md:flex-column lg:flex-column xl:flex-row gap-3"
  >
    @for(agendamento of AgendaDataService.$agendamentos(); track agendamento.id; let i = $index){
    @let nomeCliente = obterNomeCliente(agendamento);
    @let telefoneCliente = obterTelefoneCliente(agendamento);
    @let telefoneResponsavel = obterTelefoneResponsavel(agendamento);
    <div
      class="flex border-round-lg shadow-1 surface-card overflow-hidden min-h-[70px] w-full n-card-hover"
      tabindex="0"
      role="button"
      [attr.data-tour]="i === 0 ? 'agenda-item' : null"
      (click)="acessarModalInformacao(agendamento)"
      (keyup.enter)="acessarModalInformacao(agendamento)"
    >
      <div
        class="flex flex-column justify-content-center align-items-center px-2 py-3 text-white"
        [ngClass]="obterClasseStatus(agendamento)"
        style="min-width: 60px"
      >
        @if (agendamento.isEncaixe) {
        <i
          class="pi pi-bolt text-white text-xs mb-1 cursor-pointer"
          [attr.aria-label]="'BARDO_AGENDA.ENCAIXE_LABEL' | translate"
          [pTooltip]="'BARDO_AGENDA.ENCAIXE_LABEL' | translate"
          tooltipPosition="top"
        ></i>
        }
        <span class="font-bold text-sm">{{
          formatarHoraAgendamento(agendamento)
        }}</span>
        <span class="text-xs">{{ formatarDataAgendamento(agendamento) }}</span>
      </div>

      <div class="flex px-3 py-2 w-full gap-3">
        <div class="flex flex-wrap sm:gap-2 md:gap-2 lg:gap-3 xl:gap-4">
          <div class="text-sm">
            <p class="font-normal m-0">{{ $nicho().cliente.singular }}:</p>
            <p class="font-bold m-0 nome-truncado">
              @if (nomeCliente) {
              {{ nomeCliente }}
              } @else { — }
            </p>
          </div>
          <div class="text-sm">
            <p class="font-normal m-0">{{ 'ACOES.TELEFONE' | translate }}:</p>
            <p class="font-bold m-0 nome-truncado">
              @if (telefoneCliente) {
              {{ formatarTelefoneValor(telefoneCliente) }}
              } @else if (telefoneResponsavel) {
              <span
                class="n-telefone-responsavel"
                [title]="
                  ('BARDO_AGENDA.TELEFONE_RESPONSAVEL' | translate) +
                  (agendamento.responsavelNome
                    ? ': ' + agendamento.responsavelNome
                    : '')
                "
              >
                {{ formatarTelefoneValor(telefoneResponsavel) }}
              </span>
              } @else { — }
            </p>
          </div>
        </div>

        <div class="flex flex-wrap sm:gap-2 md:gap-2 lg:gap-3 xl:gap-4">
          <div class="text-sm">
            <p class="font-normal m-0">{{ $nicho().profissional.singular }}:</p>
            <p class="font-bold m-0 nome-truncado">
              {{ agendamento.profissional?.nome ?? '—' }}
            </p>
          </div>
          <div class="text-sm">
            <p class="font-normal m-0">{{ $nicho().servico.singular }}:</p>
            <p class="font-bold m-0 nome-truncado">
              {{ agendamento.servico?.nome ?? '—' }}
            </p>
          </div>
        </div>

      </div>
    </div>

    }@empty {
    <div>
      <div
        class="text-center p-3 n-nenhum-cadastrado flex gap-2 align-items-center justify-content-center"
      >
        <i class="pi pi-calendar" style="font-size: 1.5rem"></i>
        {{ 'BARDO_AGENDA.NENHUM_AGENDAMENTO' | translate }}
      </div>
    </div>
    }
  </div>

  <lib-agenda-modal-informacao-agendamento
    [($modalIsVisible)]="$modalIsVisible"
    [agendamento]="agendamento"
  ></lib-agenda-modal-informacao-agendamento>
</div>
